import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { residentApi, RES_TOKEN_KEY } from "@/lib/api";

export type Resident = { id: string; email: string; name: string; phone?: string; stay: null | { property_id: string; tenant_id: string } };
type Ctx = { resident: Resident | null | undefined; login: (token: string) => Promise<void>; logout: () => void; reload: () => Promise<void> };
const ResCtx = createContext<Ctx>(null as any);

export function ResidentProvider({ children }: { children: React.ReactNode }) {
  const [resident, setResident] = useState<Resident | null | undefined>(undefined);
  const reload = useCallback(async () => {
    if (!localStorage.getItem(RES_TOKEN_KEY)) return setResident(null);
    try {
      const r = await residentApi.get("/resident/me");
      setResident(r.data);
    } catch {
      setResident(null);
    }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const login = async (token: string) => {
    localStorage.setItem(RES_TOKEN_KEY, token);
    await reload();
  };
  const logout = () => {
    localStorage.removeItem(RES_TOKEN_KEY);
    setResident(null);
  };
  return <ResCtx.Provider value={{ resident, login, logout, reload }}>{children}</ResCtx.Provider>;
}

export const useResident = () => useContext(ResCtx);
